import { Dialog } from "@mui/material";
import React from "react";
import styled, { css } from "styled-components";
interface Props {
  isShowing: boolean;
  onClose: any;
  innerRef?: any;
  divStyle?: any;
  children?: any;
  [otherProps: string]: any;
}

const AppModel: React.FC<Props> = ({
  isShowing,
  onClose,
  innerRef,
  divStyle,
  children,
  ...otherProps
}) => {
  if (isShowing) {
    return (
      <StyledDialog open={isShowing} onClose={onClose} {...otherProps}>
        <StyledModelBox style={divStyle} {...otherProps}>
          {children}
        </StyledModelBox>
      </StyledDialog>
    );
  }

  return null;
};

export default AppModel;

const StyledDialog = styled(Dialog)`
  && {
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.5);

    /* Redesign only. MUI's default paper margin is 32px a side, and the widget
       panel is as narrow as 360px, so that alone was enough to overflow it. */
    ${({ theme }: any) =>
    theme?.industry_style?.enabled &&
    css`
      .MuiDialog-paper {
        margin: 12px;
        max-width: calc(100% - 24px);
        max-height: calc(100% - 24px);
        border-radius: 20px;
        box-shadow: 0 18px 44px rgba(16, 18, 40, 0.28);

        /* The scroll is a safety net for very short panels — it should never
           be visible chrome, because the card is sized to fit without it. */
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .MuiBackdrop-root {
        background-color: rgba(24, 26, 54, 0.45);
        backdrop-filter: blur(3px);
      }
    `}

    small {
      cursor: default;
      font-family: Poppins;
      font-weight: 400;
      font-size: 0.9rem;
      line-height: 30px;
      color: #7e8392;
    }

    .MuiDialogContent-root {
      padding: 1rem 1.5rem 0rem;
    }
  }
`;
const StyledModelBox = styled.div`
  && {
    padding: 0.7rem 0.7rem;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;

    .title {
      font-family: ${({ theme }) =>
        theme?.components?.bot_message?.text?.family};
      font-weight: 500;
      font-size: ${({ theme }) => theme?.components?.bot_message?.text?.size};
      font-size: 16px;
      color: ${({ theme }) => theme?.components?.bot_message?.text?.color};
    }
    .content {
      font-family: ${({ theme }) =>
        theme?.components?.bot_message?.text?.family};
      font-weight: 400;
      font-size: ${({ theme }) => theme?.components?.bot_message?.text?.size};
      font-size: 15px;
      color: ${({ theme }) => theme?.components?.bot_message?.text?.color};
      margin: 0.1rem 0;
    }
    .actionBtn {
      display: flex;
      flex-direction: row;
      justify-content: right;
      gap: 1.2rem;
    }
  }
`;
